import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { blogPosts } from "../../data/blogData";
import Navbar from "../Navbar";

const SeccionBlog = () => {
  const { lang } = useParams();
  const { t } = useTranslation();

  useEffect(() => {
    localStorage.setItem("colorFooter", "white");
    localStorage.setItem("colorNav", "color");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="bg-white min-h-screen">
      <Navbar />

      <section className="max-w-7xl mx-auto px-4 py-6">
        <div className="text-left mb-12 mt-10">
          <h2 className="text-orangeAtm font-bold text-4xl md:text-8xl">
            Blog
          </h2>
          <p className="mt-4 text-xl text-gray-500">
            {lang === "es"
              ? "Explora nuestros artículos y novedades."
              : "Explore our latest news and articles."}
          </p>
        </div>
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {blogPosts.map((post) => {
            const content = post[lang] || post["en"];
            return (
              <Link
                key={post.id}
                to={`/${lang}/blog/${content.slug}`}
                className="block"
              >
                <article className="flex flex-col overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all hover:shadow-xl hover:-translate-y-1 cursor-pointer">
                  <img
                    className="h-52 w-full object-cover"
                    src={content.imagen}
                    alt={content.titulo}
                  />
                  <div className="flex flex-1 flex-col justify-between p-6">
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-[#19235C] leading-tight">
                        {content.titulo}
                      </h3>
                      <p className="mt-3 text-base text-gray-500 line-clamp-3">
                        {content.descripcion}
                      </p>
                    </div>
                    <span className="mt-6 text-sm font-bold nav-text-color inline-flex items-center">
                      {lang === "es" ? "Leer más" : "Read more"} →
                    </span>
                  </div>
                </article>
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default SeccionBlog;
